import { createEl, addEl } from 'lmnt';

import PathUpdate from './PathUpdate';

export default class Cockpit {
  constructor(state) {
    this.state = state;
    this.el = createEl('div', {
      className: 'airplane-cockpit',
    });


    // / audio/cc and possibly tracking
   	 	this._path = PathUpdate.getInstance(); 


 		// / create button hotspots
    // / images are layered and invisible hotspots sit on top of the layered
    // / images. Hotspots may shift off position slightly, but will not be visible
    this.buttons = createEl('div', { className: 'cockpit_buttons' });

    this.button_contact = createEl('button', 			{ className: 'cockpit_btn_contact' }, {}, 		{ click: () => { this.showPopup('Contact'); }, mouseover: (e) => { this._over('contact'); }, mouseout: (e) => { this._out('contact'); } });
    this.button_instructions = createEl('button', 			{ className: 'cockpit_btn_instructions' }, {}, 	{ click: () => { this.showPopup('FlightInstructions'); }, mouseover: (e) => { this._over('instructions'); }, mouseout: (e) => { this._out('instructions'); } });
    //this.button_closedc = createEl('button', 			{ className: 'cockpit_btn_closedc' }, {}, 		{ click: () => { this.toggleCC(); }, mouseover: (e) => { this._over('closedc'); }, mouseout: (e) => { this._out('closedc'); } });
      //this.button_audio = createEl('button', { className: 'cockpit_btn_audio' }, {}, { click: () => { this.toggleAudio(); }, mouseover: (e) => { this._over('audio'); }, mouseout: (e) => { this._out('audio'); } });
      this.button_settings = createEl('button', { className: 'cockpit_btn_settings' }, {}, { click: () => { this.showPopup('Settings'); }, mouseover: (e) => { this._over('settings'); }, mouseout: (e) => { this._out('settings'); } });

      this.button_summary = createEl('button', { className: 'cockpit_btn_summary' }, {}, { click: () => { this.showPopup('Summary'); }, mouseover: (e) => { this._over('summary'); }, mouseout: (e) => { this._out('summary'); } });
       

      this.button_menu = createEl('button', { className: 'cockpit_btn_menu' }, {}, { click: () => { this.showPopup('Menu'); }, mouseover: (e) => { this._over('menu'); }, mouseout: (e) => { this._out('menu'); } });

      




    this.buttons.appendChild(this.button_contact); 
    this.buttons.appendChild(this.button_instructions);
      //this.buttons.appendChild(this.button_closedc);
      this.buttons.appendChild(this.button_settings);

      this.buttons.appendChild(this.button_summary);
       
      this.buttons.appendChild(this.button_menu);
      //this.buttons.appendChild(this.reset_btn);



    // / these buttons are enabled until flying
    this.button_contact.disabled = true;
    this.button_menu.disabled = true;
      this.button_instructions.disabled = true;
      this.button_summary.disabled = true;
      //this.button_settings.disabled = true;



    // / create layers for different states/ button states layered
    this.layers = createEl('div', { className: 'cockpit_layers' });
    this.layer_lights_on = createEl('div', { className: 'cockpit_lights_on' });
    this.layer_lights_off = createEl('div', { className: 'cockpit_lights_off' });


    // / to accommodate fluid responsive cockpit and scaling content
    // / multiple layer are used instead of sprite sheets to position different buttons/ states
    //this.layer_audio = createEl('div', { className: 'cockpit_layer_audio boff' });
    this.layer_summary = createEl('div', { className: 'cockpit_layer_summary boff' });

    this.layer_contact = 		createEl('div', { className: 'cockpit_layer_contact boff' });
    this.layer_instructions = createEl('div', { className: 'cockpit_layer_instructions boff' });
    //this.layer_closedc = 	 	createEl('div', { className: 'cockpit_layer_closedc boff' });
      this.layer_settings = createEl('div', { className: 'cockpit_layer_settings boff' });
      this.layer_summary = createEl('div', { className: 'cockpit_layer_summary boff' });
    this.layer_menu = createEl('div', { className: 'cockpit_layer_menu boff' });


    // / start screen instructions
    this.layer_btn_instr = createEl('div', { className: 'cockpit_btn_instr off' });

    // / glow behind the outro screens
    this.layer_end_glow = createEl('div', { className: 'cockpit_layer_end_glow' });


    // / add all the layers
    this.layers.appendChild(this.layer_lights_on);
    this.layers.appendChild(this.layer_lights_off);
    //this.layers.appendChild(this.layer_audio);

    this.layers.appendChild(this.layer_summary);

    this.layers.appendChild(this.layer_contact);
    this.layers.appendChild(this.layer_instructions);
    //this.layers.appendChild(this.layer_closedc);
      this.layers.appendChild(this.layer_settings);
    this.layers.appendChild(this.layer_menu);
    this.layers.appendChild(this.layer_btn_instr);

    addEl(this.el, this.layer_end_glow, this.layers, this.buttons);

    this.preloadImages();


    // / accessibility
    this.layer_lights_on.setAttribute('role', 'img');
    this.layer_lights_off.setAttribute('role', 'img');
    //this.layer_audio.setAttribute('role', 'img');
    this.layer_summary.setAttribute('role', 'img');
    this.layer_contact.setAttribute('role', 'img');
    this.layer_instructions.setAttribute('role', 'img');
    //this.layer_closedc.setAttribute('role', 'img');
      this.layer_settings.setAttribute('role', 'img');
    this.layer_menu.setAttribute('role', 'img');
    this.layer_btn_instr.setAttribute('role', 'img');


    this.layer_lights_on.setAttribute('aria-label', 'Cockpit bottom: light');
    this.layer_lights_off.setAttribute('aria-label', 'Cockpit bottom: dark');
      //this.layer_audio.setAttribute('aria-label', 'Audio icon: blue');
      this.layer_summary.setAttribute('aria-label', 'Summary icon: blue');

    //this.layer_closedc.setAttribute('aria-label', 'Closed captions icon: blue');
      this.layer_settings.setAttribute('aria-label', 'Settings icon: blue');

    this.layer_contact.setAttribute('aria-label', 'Contact rep icon: blue');
    this.layer_instructions.setAttribute('aria-label', 'Instructions icon: blue');
    this.layer_menu.setAttribute('aria-label', 'Menu icon: blue');
    this.layer_btn_instr.setAttribute('aria-label', 'Cockpit instructions ');
  }


  preloadImages() {
    	const _this = this; const
      im = '';
    ['contact',
      //'closedc_off',
      //'closedc',
        'settings_off',
        'settings',
      'instructions',
      //'audio',
      //'audio_off',
        'summary',
        'summary_off',
      'menu'].forEach((cls) => {
      _this.preImg(`/assets/images/cockpit/btn_${cls}.png`);
    });

    ['contact',
     // 'closedc',
        'settings',
      'instructions',
      //'audio',
        'summary',
      'menu'].forEach((cls) => {
      _this._over(cls);
      setTimeout(() => {
        _this._out(cls);
      }, 50);
    });
  }

  preImg(n) {
    const img = new Image();
    img.src = n;
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
  }


  // / add class to the body to switch cockpit lights from on to off
  turnOnLights() {
   		document.body.classList.add('lightsOn');
  }

  // / disable all Cockpit buttons
  turnOnAllbuttons() {
    this.button_contact.disabled = false;
    this.button_menu.disabled = false;
    this.button_instructions.disabled = false;
      //this.button_closedc.disabled = false;
      //this.button_settings.disabled = false; 

      this.button_summary.disabled = false;

    //this.button_audio.disabled = false;
  }

  // / activate menu button (on takeoff)
  turnOnMenubutton() {
 		this.button_menu.disabled = false;
  }

  // / call the static pathupdate class to turn off all audio in the application
  toggleAudio() {
    //this._path.toggleAudio();
      //console.log("clicked");
  }

  // / cc is displayed based on class in body to show/hide.
  // / note: MOA video cc is decoupled from global voice over cc
  toggleCC() {
    //const _m = document.querySelector('#moa-video');
	   // window._CC = !window._CC;
    //if (window._CC) {
    //  document.body.classList.add('hasCC');
    //} else {
    //  document.body.classList.remove('hasCC');
    //}

     // console.log("cc clicked");
    // / this.state.popup = 'outro'; (to test outro)
  }

  // / method to show/ hide popup
  // / this method toggles if you send it current popup open

  showPopup(title) {
    	if (this.state.popup == title) {
      this._path.update('closeView');
      this.state.popup = null;
    	} else {
    		this.state.popup = title;
      }

      let settingsPopup = document.querySelector(".popup_settings");

      if (title == "Settings") {

          if (settingsPopup.classList.contains("hidden")) {
              document.querySelector(".intro-content").classList.remove("hide_intro");

          } else {
              document.querySelector(".intro-content").classList.add("hide_intro"); 

          }

      }
  }


  // / this method is only the instruction on the start screens
  // / and not related to inflight instructions pop up
  // / true / false to show hide the start instructions (turn on buttons)
  intructions(n) {
    	if (n) {
    		this.layer_btn_instr.classList.remove('off'); 
    		//this.layer_audio.classList.remove('boff'); 
    	    this.layer_summary.classList.remove('boff');
            this.layer_contact.classList.remove('boff');
    		//this.layer_closedc.classList.remove('boff');
            this.layer_settings.classList.remove('boff');
    		this.layer_instructions.classList.remove('boff');
    	} else {
      		this.layer_btn_instr.classList.add('off');
      		this.layer_menu.classList.remove('boff');
    	}
  }


  // / button hover states
  _over(n) {
    	this[`layer_${n}`].classList.add('hover');
  }

  _out(n) {
     	this[`layer_${n}`].classList.remove('hover');
  }
}
